import { Stack } from '@mui/material';
import { PrescriptionAndUnhandledOrdersProvider } from 'Context';
import { MedicationsAndPrescriptionsMain } from './MedicationsAndPrescriptionsMain';
import { useIsDesktop } from 'Hooks';
import { CustomMetaTitle } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

export const MedicationsAndPrescriptionsLobby = () => {
  const isDesktop = useIsDesktop();
  return (
    <Stack pb={isDesktop ? '155px' : ''}>
      <CustomMetaTitle
        title={Dictionary[DICTIONARY.MedicationsAndPrescriptionsLobby].title}
      />
      <PrescriptionAndUnhandledOrdersProvider>
        <MedicationsAndPrescriptionsMain />
      </PrescriptionAndUnhandledOrdersProvider>
    </Stack>
  );
};
